import React, { Component } from 'react';
// import { Link } from 'react-router-dom';
import { Row, Col, Card, Badge } from 'react-bootstrap'



function UiBadge() {

    return (
        <>
            <Row>
                <Col xl={6}>
                    <Card>
                        <Card.Header>
                            <Card.Title>Badge</Card.Title>
                        </Card.Header>
                        <Card.Body>
                            <Badge className="mb-2 mr-2" variant="primary">Primary</Badge>{' '}
                            <Badge className="mb-2 mr-2" variant="secondary">Secondary</Badge>{' '}
                            <Badge className="mb-2 mr-2" variant="success">Success</Badge>{' '}
                            <Badge className="mb-2 mr-2" variant="danger">Danger</Badge>{' '}
                            <Badge className="mb-2 mr-2" variant="warning">Warning</Badge> 
							<Badge className="mb-2 mr-2" variant="info">Info</Badge>{' '}
                            <Badge className="mb-2 mr-2" variant="light">Light</Badge> 
							<Badge className="mb-2 mr-2" variant="dark">Dark</Badge>
                        </Card.Body>
                    </Card>
                </Col>

                <Col xl={6}>
                    <Card>
                        <Card.Header>
                            <Card.Title>Pill</Card.Title>
                        </Card.Header>
                        <Card.Body>
                            <Badge className="mb-2 mr-2" pill variant="primary">Primary</Badge>{' '}
                            <Badge className="mb-2 mr-2" pill variant="secondary">Secondary</Badge>{' '}
                            <Badge className="mb-2 mr-2" pill variant="success">Success</Badge>{' '}
                            <Badge className="mb-2 mr-2" pill variant="danger">Danger</Badge>{' '}
                            <Badge className="mb-2 mr-2" pill variant="warning">Warning</Badge>{' '}
                            <Badge className="mb-2 mr-2" pill variant="info">Info</Badge>{' '}
                            <Badge className="mb-2 mr-2" pill variant="light">Light</Badge>{' '}
                            <Badge className="mb-2 mr-2" pill variant="dark">Dark</Badge>
                        </Card.Body>
                    </Card>
                </Col>
            </Row>
        </>
    )
}

export default UiBadge;